import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateFiveButtons = ({
  backgroundType = "color",
  backgroundColor = "#3B0F4A",
  backgroundImage = null,

  // Button 1
  button1Label = "Website",
  button1Link = "",
  button1Font = "Helvetica",
  button1FontSize = "18",
  button1FontColor = "#F5F5F5",
  button1BackgroundColor = "#EBC85B",
  button1IsBold = false,
  button1IsItalic = false,
  button1IsUnderline = false,

  // Button 2
  button2Label = "Demo Page",
  button2Link = "",
  button2Font = "Helvetica",
  button2FontSize = "18",
  button2FontColor = "#6D2B1F",
  button2BackgroundColor = "#F4A261",
  button2IsBold = false,
  button2IsItalic = false,
  button2IsUnderline = false,

  // Button 3
  button3Label = "Knowledge Base",
  button3Link = "",
  button3Font = "Helvetica",
  button3FontSize = "18",
  button3FontColor = "#5A1F1F",
  button3BackgroundColor = "#F0805A",
  button3IsBold = false,
  button3IsItalic = false,
  button3IsUnderline = false,

  // Button 4
  button4Label = "Newsletter Signup",
  button4Link = "",
  button4Font = "Helvetica",
  button4FontSize = "18",
  button4FontColor = "#FFFFFF",
  button4BackgroundColor = "#E04646",
  button4IsBold = false,
  button4IsItalic = false,
  button4IsUnderline = false,

  // Button 5
  button5Label = "Book a Call",
  button5Link = "",
  button5Font = "Helvetica",
  button5FontSize = "18",
  button5FontColor = "#FFFFFF",
  button5BackgroundColor = "#C62828",
  button5IsBold = false,
  button5IsItalic = false,
  button5IsUnderline = false,

  backgroundImagePreview,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  // if an image exists, clear the background color so image shows through
  if (
    (backgroundImage && !["null", null].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";

  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  // small helper to open links
  const openLink = (link) => {
    if (!link) return;
    window.open(link, "_blank");
  };

  return (
    <div
    className={`relative ${
      !inmeeting
        ? "h-auto"
        : ["top", "bottom"].includes(position)
        ? "h-[150px]"
        : "!h-[89vh] mt-[5%]"
    } w-full flex flex-row mx-auto items-center px-4 md:px-8 py-3 md:py-4 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              // Keep pattern from other templates: call onClose or fallback to setActiveElement
              onClose && onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative h-full z-10 flex justify-center items-center w-full mx-auto gap-4 md:gap-6">
        {/* Main Heading */}

        {/* Five Buttons Row */}
        <div className="w-full flex flex-row flex-wrap justify-center items-center gap-4 px-2">
          {/* Button 1 */}
          {button1Label && String(button1Label).trim() !== "" && (
            <button
              className={`px-6 py-2 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl ${
                button1Link ? "cursor-pointer" : "cursor-default"
              }`}
              style={{
                backgroundColor: button1BackgroundColor,
                color: button1FontColor,
                fontSize: `${button1FontSize}px`,
                fontFamily: button1Font,
                fontWeight: explicitBoleanCheck(button1IsBold)
                  ? "bold"
                  : "normal",
                fontStyle: explicitBoleanCheck(button1IsItalic)
                  ? "italic"
                  : "normal",
                textDecoration: explicitBoleanCheck(button1IsUnderline)
                  ? "underline"
                  : "none",
              }}
              onClick={() => openLink(button1Link)}
            >
              {button1Label}
            </button>
          )}

          {/* Button 2 */}
          {button2Label && String(button2Label).trim() !== "" && (
            <button
              className={`px-6 py-2 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl ${
                button2Link ? "cursor-pointer" : "cursor-default"
              }`}
              style={{
                backgroundColor: button2BackgroundColor,
                color: button2FontColor,
                fontSize: `${button2FontSize}px`,
                fontFamily: button2Font,
                fontWeight: explicitBoleanCheck(button2IsBold)
                  ? "bold"
                  : "normal",
                fontStyle: explicitBoleanCheck(button2IsItalic)
                  ? "italic"
                  : "normal",
                textDecoration: explicitBoleanCheck(button2IsUnderline)
                  ? "underline"
                  : "none",
              }}
              onClick={() => openLink(button2Link)}
            >
              {button2Label}
            </button>
          )}

          {/* Button 3 */}
          {button3Label && String(button3Label).trim() !== "" && (
            <button
              className={`px-6 py-2 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl ${
                button3Link ? "cursor-pointer" : "cursor-default"
              }`}
              style={{
                backgroundColor: button3BackgroundColor,
                color: button3FontColor,
                fontSize: `${button3FontSize}px`,
                fontFamily: button3Font,
                fontWeight: explicitBoleanCheck(button3IsBold)
                  ? "bold"
                  : "normal",
                fontStyle: explicitBoleanCheck(button3IsItalic)
                  ? "italic"
                  : "normal",
                textDecoration: explicitBoleanCheck(button3IsUnderline)
                  ? "underline"
                  : "none",
              }}
              onClick={() => openLink(button3Link)}
            >
              {button3Label}
            </button>
          )}

          {/* Button 4 */}
          {button4Label && String(button4Label).trim() !== "" && (
            <button
              className={`px-6 py-2 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl ${
                button4Link ? "cursor-pointer" : "cursor-default"
              }`}
              style={{
                backgroundColor: button4BackgroundColor,
                color: button4FontColor,
                fontSize: `${button4FontSize}px`,
                fontFamily: button4Font,
                fontWeight: explicitBoleanCheck(button4IsBold)
                  ? "bold"
                  : "normal",
                fontStyle: explicitBoleanCheck(button4IsItalic)
                  ? "italic"
                  : "normal",
                textDecoration: explicitBoleanCheck(button4IsUnderline)
                  ? "underline"
                  : "none",
              }}
              onClick={() => openLink(button4Link)}
            >
              {button4Label}
            </button>
          )}

          {/* Button 5 */}
          {button5Label && String(button5Label).trim() !== "" && (
            <button
              className={`px-6 py-2 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl ${
                button5Link ? "cursor-pointer" : "cursor-default"
              }`}
              style={{
                backgroundColor: button5BackgroundColor,
                color: button5FontColor,
                fontSize: `${button5FontSize}px`,
                fontFamily: button5Font,
                fontWeight: explicitBoleanCheck(button5IsBold)
                  ? "bold"
                  : "normal",
                fontStyle: explicitBoleanCheck(button5IsItalic)
                  ? "italic"
                  : "normal",
                textDecoration: explicitBoleanCheck(button5IsUnderline)
                  ? "underline"
                  : "none",
              }}
              onClick={() => openLink(button5Link)}
            >
              {button5Label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HorizontalTemplateFiveButtons;
